import { render, staticRenderFns } from "./SelectClassPickList.vue?vue&type=template&id=45ab7028&scoped=true&"
import script from "./SelectClassPickList.vue?vue&type=script&lang=ts&"
export * from "./SelectClassPickList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ab7028",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
